import { ObjectMapper } from "json-object-mapper";
import { InsightModel } from "./insight.model";

export class InsightOvertimeModel extends InsightModel {
  tradeUnions: string[] = [];

  static create(input: any): InsightOvertimeModel {
    return ObjectMapper.deserialize<InsightOvertimeModel>(InsightOvertimeModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}